export default function normalizeToLowerStringArray(input: unknown): string[] {
    if (input == null) return [];

    const arr = Array.isArray(input) ? input : [input];

    return arr
        .flatMap((v) => (v == null ? [] : [String(v)]))
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);
}
